/**
 * @generated SignedSource<<3fb90733dbab34201f9f64736eff66d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipsFrom_item$data = {
  readonly address: {
    readonly itemAddress: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedDetailShipsFrom_item";
};
export type PdpSharedDetailShipsFrom_item$key = {
  readonly " $data"?: PdpSharedDetailShipsFrom_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipsFrom_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipsFrom_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": "itemAddress",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a30dcf2c93a14e834f0b5af680f91c0c";

export default node;
